<div class="flex flex-col h-full">
  <hs-tab-group class="flex-1 overflow-y-auto">
    <hs-tab label="{{ addressTabLabel }}">
      <hs-contact-form
        class="layer-two"
        [(contact)]="contact"
      ></hs-contact-form>
    </hs-tab>
    <hs-tab label="{{ logoTabLabel }}">
      <kfm-contact-logo
        class="layer-two mt-4"
        [contact]="contact()"
      ></kfm-contact-logo>
    </hs-tab>
    <hs-tab label="{{ bankTabLabel }}">
      <kfm-contact-bank-account-form
        class="layer-two"
        [bankAccount]="bankAccount()"
        [contactType]="contactType()"
        (bankAccountChanged)="bankAccount.set($event)"
      ></kfm-contact-bank-account-form>
    </hs-tab>
    <hs-tab label="{{ idTabLabel }}">
      <kfm-contact-registrations
        class="layer-two"
        [registrations]="registrations()"
        [contactType]="contactType()"
      ></kfm-contact-registrations>
    </hs-tab>
  </hs-tab-group>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelButtonLabel }}
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="onOkClicked()"
    >
      {{ okButtonLabel }}
    </button>
  </div>
</div>
